var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ies-form-field", { attrs: { field: _vm.field } }, [
    _c(
      "div",
      { staticClass: "ies-switch" },
      [
        _c("v-switch", {
          attrs: {
            "hide-details": "",
            label: _vm.labelString,
            color: _vm.colorParsed,
            disabled: this.field.disabled,
          },
          on: {
            change: function ($event) {
              return _vm.updateField()
            },
          },
          model: {
            value: _vm.input,
            callback: function ($$v) {
              _vm.input = $$v
            },
            expression: "input",
          },
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { name: this.field.fieldName, type: "hidden" },
          domProps: { value: _vm.input },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }